export default {"src":"/_next/static/image/public/images/flags/flag_63.6f6c2584d45b129aa9647728adb6b0ae.svg","height":16,"width":24};